// Mapeo de códigos ISO numéricos a símbolos de moneda
const CURRENCY_SYMBOLS = {
  '032': 'AR$',  // Peso argentino
  '214': 'RD$',  // Peso dominicano
  '152': 'CLP',  // Peso chileno
  '484': 'MX$',  // Peso mexicano
  '840': 'US$',  // Dólar estadounidense
  '858': 'UY$',  // Peso uruguayo
  '604': 'S/',   // Sol peruano
  '986': 'R$',   // Real brasileño
  // Agregar más según necesites
};

export const getCurrencySymbol = (currencyCode) => {
  return CURRENCY_SYMBOLS[currencyCode] || '$';
};

export const formatCurrency = (amount, currencyCode) => {
  const symbol = getCurrencySymbol(currencyCode);
  const value = Math.abs(amount / 100); // Convertir centavos a unidad
  
  return `${symbol}${value.toLocaleString('es-AR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

